import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Header from 'components/Modal/Header';
import Modal from 'components/Modal';

// default modal with just title and subtitle and buttons to confirm or go back
const DefaultModal = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Header title={modalProps?.title ?? t('modal-title')} subtitle={modalProps?.subtitle ?? t('modal-subtitle')} />
      <Modal.Footer
        withConfirmButton={modalProps?.func !== undefined}
        confirmAction={modalProps?.func}
        confirmText={modalProps?.confirmText ?? t('continue')}
        closeButtonText={modalProps?.backText ?? t('back')}
        cancelAction={modalProps?.backFunc}
      />
    </>
  );
};

export default DefaultModal;
